// extracted by mini-css-extract-plugin
module.exports = {"i-table":"index_i-table_3kWem"};